export default __webpack_public_path__ + "static/media/Artist.cea58f85.jpg";